export class SkillAvailableDefinition {
    MaxWaitTimeSeconds?: number;
    MinAgentCapacity?: number;
    MinActiveAgents?: number;
    WithinBusinessHour?: boolean;
    MinCloseTimeInSeconds?: number;
    MinCapacityPercentage?: number;
    Status?: string;
}
